var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 18,
    viewBox: "0 0 9 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.14645 17.3536C4.34171 17.5488 4.65829 17.5488 4.85355 17.3536L8.03553 14.1716C8.2308 13.9763 8.2308 13.6597 8.03553 13.4645C7.84027 13.2692 7.52369 13.2692 7.32843 13.4645L4.5 16.2929L1.67157 13.4645C1.47631 13.2692 1.15973 13.2692 0.964466 13.4645C0.769204 13.6597 0.769204 13.9763 0.964466 14.1716L4.14645 17.3536ZM5 1C5 0.723858 4.77614 0.5 4.5 0.5C4.22386 0.5 4 0.723858 4 1H5ZM5 17V1H4V17H5Z",
    fill: "currentcolor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/downArrow.f9ee576b7f5b3f76e8d6d5b6571a7224.svg";